import { frontendURL } from 'dashboard/helper/URLHelper';
import InboxListView from './InboxList.vue';
import InboxDetailView from './InboxView.vue';
import InboxEmptyStateView from './InboxEmptyState.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/inbox-view'),
    component: InboxListView,
    children: [
      {
        path: '',
        name: 'inbox_view',
        component: InboxEmptyStateView,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.CHATWOOT_V4,
        },
      },
      {
        // Bound to the conversation, not to the notification: the backend
        // replaces the notification when a new one arrives for the same
        // conversation, and the open conversation must stay open.
        path: ':type/:id',
        name: 'inbox_view_conversation',
        component: InboxDetailView,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          featureFlag: FEATURE_FLAGS.CHATWOOT_V4,
        },
      },
      {
        // Old links used the notification id. That notification can be gone,
        // so open the list.
        path: ':notification_id(\\d+)',
        redirect: to => ({
          name: 'inbox_view',
          params: { accountId: to.params.accountId },
        }),
      },
    ],
  },
];
